import MuiRadio from '@mui/material/Radio';

import { styled } from 'helpers';

import { RadioProps } from './';

export const Radio = styled(MuiRadio)<RadioProps>`
  color: ${({ theme }) => theme.palette.blueGrey['A400']};
  padding: 2px;
  width: 24px;
  height: 24px;

  &:hover {
    color: ${({ theme }) => theme.palette.blueGrey['A600']};
    background-color: unset;
  }

  &.Mui-checked {
    color: ${({ theme }) => theme.palette.blue['800']};

    &:hover {
      color: ${({ theme }) => theme.palette.blue['900']};
    }
  }

  &.Mui-focusVisible {
    outline: 2px solid ${({ theme }) => theme.palette.lightBlue['400']};
    outline-offset: -2.5px;
  }

  &.Mui-disabled {
    color: ${({ theme }) => theme.palette.blueGrey['A100']};
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.palette.grey['50']};
  }

  & + span.MuiFormControlLabel-label {
    margin-left: 10px;
  }
`;

export default Radio;
